import React from "react";
import { Alert, Button, Col, Form, Modal, Row, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Formik } from "formik";
import * as Yup from "yup";
import { savePlantillaCuestionarios } from "../../redux/climalaboral/plantillaCuestionario/action";

const ModalNewCuestionaire = (props) => {
  const schema = Yup.object().shape({
    nombre: Yup.string().ensure().required("**Campo requerido"),
    descripcion: Yup.string().ensure().required("**Campo requerido"),
    objeto: Yup.string().ensure().required("**Campo requerido"),
  });

  const { category, loading } = useSelector((store) => store.category);

  const { saveLoader, formError } = useSelector(
    (store) => store.plantillaCuestionario
  );

  const dispatch = useDispatch();
  const history = useHistory();
  const onSubmit = (req) => {
    dispatch(savePlantillaCuestionarios(req, history));
  };
  return (
    <>
      <Modal show={props.showModal} onHide={() => props.setShowModal(false)}>
        <Formik
          validationSchema={schema}
          onSubmit={onSubmit}
          initialValues={{
            nombre: props.edit ? props.editItem.nombre : "",
            descripcion: props.edit ? props.editItem.descripcion : "",
            objeto: props.edit ? props.editItem.objeto : "",
          }}
        >
          {({
            handleSubmit,
            handleChange,
            handleBlur,
            setFieldValue,
            values,
            touched,
            isValid,
            errors,
          }) => (
            <Form onSubmit={handleSubmit}>
              <Modal.Header closeButton>
                <Modal.Title>Nuevo Cuestionario</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {!!formError && (
                  <Alert variant="danger" className="mt-1 mb-3">
                    {formError}
                  </Alert>
                )}
                <Row>
                  <Form.Group as={Col} className="mb-3">
                    <Form.Label column sm="12" md="12">
                      Titulo del cuestionario:
                    </Form.Label>
                    <Form.Control
                      name="nombre"
                      className="rounded-pill"
                      type="text"
                      value={values.nombre}
                      onBlur={handleBlur("nombre")}
                      onChange={handleChange}
                      isInvalid={touched.nombre && !!errors.nombre}
                      isValid={touched.nombre && !errors.nombre}
                      placeholder="Titulo del cuestionario"
                    ></Form.Control>
                    {touched.nombre && errors.nombre && (
                      <div>
                        <small className="text-danger px-2">
                          {errors.nombre}
                        </small>
                      </div>
                    )}
                    {/* <Form.Control.Feedback type="invalid">
                      **Campo requerido
                    </Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                      **Solo admite letras,numeros y los siguientes caracteres
                      @$¿?¡\-_%#
                    </Form.Control.Feedback> */}
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group as={Col} className="mb-3">
                    <Form.Label column sm="12" md="12">
                      Descripción del cuestionario:
                    </Form.Label>
                    <Form.Control
                      name="descripcion"
                      className="rounded"
                      as="textarea"
                      value={values.descripcion}
                      onBlur={handleBlur("descripcion")}
                      onChange={handleChange}
                      isInvalid={touched.descripcion && !!errors.descripcion}
                      isValid={touched.descripcion && !errors.descripcion}
                      placeholder="Titulo del cuestionario"
                    ></Form.Control>
                    {touched.descripcion && errors.descripcion && (
                      <div>
                        <small className="text-danger px-2">
                          {errors.descripcion}
                        </small>
                      </div>
                    )}
                    {/* <Form.Control
                      as="textarea"
                      required
                      name="descripcionCuestionario"
                      pattern="^[a-zA-ZÀ-ÿ\u00f1\u00d1.0-9'{}().:,;&@$¿?¡/\-_%#]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1.0-9'{}().:,;&@$¿?¡/\-_%#]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1.0-9'{}().:,;&@$¿?¡/\-_%#]+$"
                      // pattern="^[a-zA-ZÀ-ÿ\u00f1\u00d1\x26]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1\x26]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1\x26]+$"
                    ></Form.Control> */}
                    {/* <Form.Control.Feedback type="invalid">
                      **Campo requerido
                    </Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                      **Solo admite letras,numeros y los siguientes caracteres
                      @$¿?¡\-_%#
                    </Form.Control.Feedback> */}
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group as={Col} controlId="Categoria">
                    <Row className="align-items-end">
                      <Col sm={loading ? "10" : "12"}>
                        <Form.Label className="ml-2">Categoría:</Form.Label>
                        <Form.Control
                          name="objeto"
                          className="rounded-pill"
                          as="select"
                          value={values.objeto}
                          onBlur={handleBlur("objeto")}
                          onChange={handleChange}
                          isInvalid={touched.objeto && !!errors.objeto}
                          isValid={touched.objeto && !errors.objeto}
                          //   as="select"
                          //   id="categoria"
                          //   name="categoria"
                          //   className="rounded-pill"
                          //   required
                          //   placeholder="Categoría"
                        >
                          {
                            <option key="" value="" selected disabled>
                              Seleccione una categoria
                            </option>
                          }
                          {category
                            ? category
                                .sort((a, b) => {
                                  if (a.nombre && b.nombre) {
                                    if (
                                      a.nombre.toLowerCase() ===
                                      b.nombre.toLowerCase()
                                    ) {
                                      return 0;
                                    }
                                    if (
                                      a.nombre.toLowerCase() <
                                      b.nombre.toLowerCase()
                                    ) {
                                      return -1;
                                    }
                                  }
                                  return 1;
                                })
                                .map((item) => (
                                  <option
                                    key={item.id}
                                    value={item.id ? item.id : ""}
                                  >
                                    {item.nombre
                                      ? item.nombre.toUpperCase()
                                      : ""}
                                  </option>
                                ))
                            : null}
                        </Form.Control>
                        {touched.objeto && errors.objeto && (
                          <div>
                            <small className="text-danger px-2">
                              {errors.objeto}
                            </small>
                          </div>
                        )}
                        {/* <Form.Control.Feedback type="invalid">
                          **Campo requerido
                        </Form.Control.Feedback> */}
                      </Col>
                      {loading && (
                        <Col sm="2">
                          <Spinner animation="border" size="sm" />
                        </Col>
                      )}
                    </Row>
                  </Form.Group>
                </Row>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="rounded-pill"
                  disabled={saveLoader}
                  variant="primary"
                  type="submit"
                >
                  {saveLoader && (
                    <Spinner
                      className="mr-2"
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  )}
                  Guardar
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
};

export default ModalNewCuestionaire;
